package br.com.vvrefeicoes.portal.core.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.undrawable_empty

@Composable
fun EmptyState(
    message: String,
    modifier: Modifier = Modifier,
    drawable: DrawableResource = Res.drawable.undrawable_empty,
) {
    Column(
        modifier =
            modifier
                .fillMaxSize()
                .padding(AppSpacing.space24),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space24, Alignment.CenterVertically),
    ) {
        Image(
            painter = painterResource(drawable),
            contentDescription = null,
            modifier =
                Modifier
                    .widthIn(max = 480.dp)
                    .fillMaxWidth(0.8f)
                    .heightIn(max = 200.dp),
            contentScale = ContentScale.Fit,
        )
        Text(
            text = message,
            style = MaterialTheme.typography.titleMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            textAlign = TextAlign.Center,
        )
    }
}
